import Image from 'app/Components/Shared/Image/image';
import React , { useEffect } from 'react';
import { connect } from 'react-redux';
import download from '../../icons/download.svg';
import accessible from '../../icons/accessible.svg';
import billIcon from '../../icons/bill-icon.svg';
import { IdentificationActionEnum } from '../../Constant';
import { reportDWH } from '../../PersonalAreaInvoicesSlice';
import {isMobile} from 'react-device-detect';

const ButtonBar = (props) => {

  const buttons = [
    { img: download, text: 'חשבונית מס' , type: IdentificationActionEnum.DISPLAY_TAX_INVOICE , isDisplay: true },
    { img: accessible, text: 'חשבונית נגישה' , type: IdentificationActionEnum.DISPLAY_ACCESSIBLE_INVOICE , isDisplay: true},
    { img: isMobile ? null : billIcon, text: 'ריכוז חשבוניות שנתי', type: IdentificationActionEnum.DISPLAY_ANNUAL_INVOICE_CONSOLIDATION  , isDisplay: (props.systemSourcePDF == 'CLC')},
    { img: null, text: 'פירוט שיחות', type: IdentificationActionEnum.DISPLAY_CALLS_DETAILS , isDisplay: props.selectedBan?.hasCellular }
  ];

  const onClick = (type)=>{
    props.handleOnClickButtonBar(type, props.guidId, props.systemSourcePDF);
    if(type === "DISPLAY_TAX_INVOICE"){
      props.reportDWH({ actionType: 'Invoice Page', status: 'Completed', messageText:'Invoice PDF Download' });
    } else if ( type === "DISPLAY_ACCESSIBLE_INVOICE"){
      props.reportDWH({ actionType: 'Invoice Page', status: 'Completed', messageText: 'Accessibility PDF Download' });
    }else if(type == 'DISPLAY_ANNUAL_INVOICE_CONSOLIDATIONs'){
      props.reportDWH({ actionType: 'Invoice Page', status: 'Completed', messageText: 'Invoice Call List Displayed' });
    };
  };

  return (
    <div className='container-buttons'>
      {props.detailsProducts.length > 0 && buttons.map((button, index) => (
        button.isDisplay && (
          <button key={index} className='button-footer' onClick={() => onClick(button.type)}>
            {button.img && <Image src={button.img} alt='icon' />}
            <div>{button.text}</div>
          </button>
        )
      ))}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    detailsProducts: state.personalAreaInvoicesPage.detailsProducts,
    selectedBan: state.personalAreaInvoicesPage.selectedBan,
    guidId: state.personalAreaInvoicesPage.guidId,
    systemSourcePDF: state.personalAreaInvoicesPage.systemSourcePDF,
  };
};

const mapDispatchToProps = {
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(ButtonBar);
